import React, { SVGProps } from 'react';

const SvgYoutubeMinimalAfter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 41 41" {...props}>
    <path
      d="M0 10.5C0 4.97715 4.47715 0.5 10 0.5H30C35.5228 0.5 40 4.97715 40 10.5V30.5C40 36.0228 35.5228 40.5 30 40.5H10C4.47715 40.5 0 36.0228 0 30.5V10.5Z"
      fill="#FEF2F2"
    />
    <path
      d="M11.3037 24.5784C10.6764 21.7792 10.6764 18.8867 11.3037 16.0876C11.3861 15.8033 11.5453 15.5442 11.7657 15.3358C11.9861 15.1274 12.2601 14.9768 12.5607 14.8988C17.3762 14.1444 22.2903 14.1444 27.1058 14.8988C27.4064 14.9768 27.6804 15.1274 27.9008 15.3358C28.1212 15.5442 28.2804 15.8033 28.3628 16.0876C28.99 18.8867 28.99 21.7792 28.3628 24.5784C28.2804 24.8626 28.1212 25.1217 27.9008 25.3301C27.6804 25.5386 27.4064 25.6891 27.1058 25.7671C22.2903 26.5217 17.3762 26.5217 12.5607 25.7671C12.2601 25.6891 11.9861 25.5386 11.7657 25.3301C11.5453 25.1217 11.3861 24.8626 11.3037 24.5784Z"
      fill="#FB2C36"
      stroke="#FB2C36"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 23L22.1667 20.5L18 18V23Z"
      fill="#FEF2F2"
      stroke="#FEF2F2"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <g opacity="0.95238">
      <path
        d="M33 4C33 1.79086 34.7909 0 37 0C39.2091 0 41 1.79086 41 4C41 6.20914 39.2091 8 37 8C34.7909 8 33 6.20914 33 4Z"
        fill="#FB2C36"
      />
    </g>
  </svg>
);
SvgYoutubeMinimalAfter.defaultProps = {
  width: '41',
  height: '41',
  color: 'currentColor',
};
export default SvgYoutubeMinimalAfter;
